import React from 'react'
import { DidomiSDK } from '@didomi/react'

const BannerCookie = () => {
  const handleDidomiReady = didomi => {
    if (!didomi.shouldConsentBeCollected()) {
      if (window && window.thor && window.thor.onConsent) window.thor.onConsent()
    }
  }
  const handleDidomiChangeConsent = () => {
    if (window && window.thor && window.thor.onConsent) window.thor.onConsent()
  }
  return (
    <DidomiSDK
      apiKey="149b0c39-206e-41db-b6fc-0e816b7577dd"
      noticeId="yiDPMe9H"
      iabVersion={1}
      gdprAppliesGlobally
      onReady={handleDidomiReady}
      onConsentChanged={handleDidomiChangeConsent}
    />
  )
}

export default BannerCookie
